import { Box, Grid, Typography } from '@mui/material';
import { makeStyles, useTheme } from '@mui/styles';
import dynamic from 'next/dynamic';
import React from 'react';

import { WalletImg } from 'assets';
import useCustomMediaQuery from 'hooks/useCustomMediaQuery';
import { keepaApp } from 'utility/baseURL';

const LinkKit = dynamic(() => import('components/common/Link'), { loading: () => <></> });
const ImageKit = dynamic(() => import('components/common/Image'), {
	loading: () => <></>,
});
const ButtonKit = React.lazy(() =>
	import('components/kit/Button').then((module) => ({
		default: module.ButtonKit,
	})),
);

const useStyles = makeStyles((theme) => ({
	wrapper: {
		background: theme.palette.primary[200],
		borderRadius: theme.shape.medium,
		padding: '0 1.6rem',
		height: '12rem',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		position: 'relative',
		[theme.breakpoints.between('xs', 'sm')]: {
			height: '29.1rem !important',
			padding: '0 1.6rem',
		},
	},
	btn: {
		background: theme.palette.primary[700],
		color: theme.palette.primary.contrastText,
		borderRadius: theme.shape.medium,
		padding: '2rem 2.4rem',
		[theme.breakpoints.between('xs', 'sm')]: {
			marginTop: '2.4rem',
		},
	},
}));

const Wallet = () => {
	const theme = useTheme();
	const classes = useStyles();
	const { isMobile } = useCustomMediaQuery();

	return (
		<Grid container className={classes.wrapper}>
			<Grid item xs={12} md={9}>
				<Grid container display="flex" justifyContent="center" alignItems="center">
					<Grid item xs={12} md={3} position="relative">
						<Box
							{...(isMobile
								? {
										mt: isMobile ? '-8rem' : '-0.9rem',
										ml: '-20%',
									}
								: {
										position: 'absolute',
										top: isMobile ? '-8rem' : '-6.8rem',
									})}
							className={isMobile ? 'element-center' : ''}
						>
							<ImageKit
								src={WalletImg}
								priority
								objectFit="cover"
								width={isMobile ? '170px' : '200px'}
								height={isMobile ? '140px' : '159px'}
							/>
						</Box>
					</Grid>
					<Grid item xs={12} md={9} mt={isMobile ? '1.6rem' : '0'}>
						<Typography color={theme.palette.text.dark} variant="h6" fontWeight={700} lineHeight={'2.5rem'}>
							اول کیف پول فعال کن، بعد خرید کن
						</Typography>

						<Typography
							variant="subtitle1"
							color={theme.palette.text.secondary}
							fontWeight={500}
							lineHeight="2.1rem"
							style={{ marginTop: '0.8rem' }}
							textAlign="justify"
						>
							با فعالسازی کیف پول های اعتباری کیپا و دریافت اعتبار، میتوانید از فروشگاه های زیر خرید کنید
						</Typography>
					</Grid>
				</Grid>
			</Grid>
			<Grid item xs={12} md={3}>
				<Box component={LinkKit} href={keepaApp()} target="_blank">
					<React.Suspense fallback={<></>}>
						<ButtonKit fullWidth className={classes.btn}>
							مشاهده کیف پول ها و راهنمای خرید
						</ButtonKit>
					</React.Suspense>
				</Box>
			</Grid>
		</Grid>
	);
};

export default Wallet;
